<!--
  Custom Rich Text Input Component Template

  This template provides a styled rich text editor with label, helper text, and error text.
  Consistent with app-textarea-input component styling.
-->

<div class="rich-text-wrapper space-y-3">
  <!-- Label -->
  @if (label()) {
  <label [for]="id()" class="rich-text-label">
    {{ label() }}
    @if (required()) {
    <span class="required-indicator">*</span>
    }
  </label>
  }

  <!-- Editor Container -->
  <div
    class="rich-text-container"
    [class.theme-shadow]="shadow()"
    [class.disabled]="disabled"
    [class.readonly]="readonly()"
    [class.error]="errorText()"
    [class]="customClass() || ''"
    [style.min-height.px]="minHeight()"
    [style.max-height.px]="maxHeight()"
  >
    <quill-editor
      [(ngModel)]="value"
      [placeholder]="placeholder() || ''"
      [modules]="quillModules"
      [formats]="formats()"
      [theme]="theme()"
      [readOnly]="readonly() || disabled"
      format="html"
      (onEditorCreated)="onEditorCreated($event)"
      (onContentChanged)="onContentChanged($event)"
      (onFocus)="onFocusChange($event)"
      (onBlur)="onBlurChange($event)"
      [style.height.px]="minHeight()"
      [style.min-height.px]="minHeight()"
      [style.max-height.px]="maxHeight()"
    ></quill-editor>
  </div>

  <!-- Helper Text -->
  @if (helperText() && !errorText()) {
  <div class="helper-text">
    {{ helperText() }}
  </div>
  }

  <!-- Error Text -->
  @if (errorText()) {
  <div class="error-text">
    {{ errorText() }}
  </div>
  }
</div>
